var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.options)?_c('div',{staticClass:"container"},_vm._l((this.options),function(option){return _c('div',{key:option.link},[_c('div',{ref:"buyButton",refInFor:true},[_c('a',{attrs:{"target":"_blank","href":option.link}},[_c('button',{staticClass:"buy-button"},[_vm._v(_vm._s(option.name))])])])])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }